import {
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import CodeBlock from '../../CodeBlock';

function GetDdsByReference() {
  return (
    <Box sx={{ textAlign: 'left' }}>
      <Typography variant="body1" >
      This endpoint is basicaly search by internal reference number or beginning of the internal reference number.<br/>
      Returns all statements that match the internal reference number or beginning of the internal reference number.<br/>
      It will return only data that belongs to your organization.
      </Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Search by your internal reference number (3-50 chars)
      </Typography>
      <ul>
        <li>Supports partial matching (e.g. "FR-2024" finds all FR-2024* references)</li>
        <li>Returns up to 1000 matching results</li>
        <li>Case-insensitive search</li>
        <li>Includes submissions from all statuses</li>
      </ul>
      <p>Supports GET and POST requests.</p>

      <Typography variant="h6" sx={{ mt: 2 }}>
        Endpoint
      </Typography>
      <CodeBlock code="GET /api/eudr/dds/info/search?internalReferenceNumber={internal_reference_number}" />
      <CodeBlock code="POST /api/eudr/dds/info/search" />

      <Typography variant="h6" sx={{ mt: 2 }}>
        Request Body (<small>POST</small>)
      </Typography>
      <CodeBlock
        code={`{
  "internalReferenceNumber": "FR-000002"
}`}
      />

      <Typography variant="h6" sx={{ mt: 2 }}>
        Response
      </Typography>
      <CodeBlock
        code={`{
    "status": "success",
    "httpStatus": 200,
    "data": [
        {
            "identifier": "62ff83cd-524d-4477-a469-42406a58dced",
            "internalReferenceNumber": "FR-000002",
            "referenceNumber": "25HRRJ6PZZZ832",
            "verificationNumber": "MTW1ZCEH",
            "status": "AVAILABLE",
            "date": "2025-03-19T21:30:01.000Z",
            "updatedBy": "Jean Dupont"
        },
        {
            "identifier": "97800d7b-bff7-4fd8-83a6-ea71a32fb710",
            "internalReferenceNumber": "FR-000002",
            "status": "CANCELLED",
            "date": "2025-03-19T20:12:40.000Z",
            "updatedBy": "Sophie Martin"
        },
        {
            "identifier": "327246aa-40da-470e-81d8-354698a7eaa2",
            "internalReferenceNumber": "FR-000002",
            "referenceNumber": "25HRYVJNLEO828",
            "verificationNumber": "WOHYRNOQ",
            "status": "AVAILABLE",
            "date": "2025-03-19T18:50:01.000Z",
            "updatedBy": "Jean Dupont"
        },
        {
            "identifier": "85532f9a-4ec1-4430-bcac-bfd8bb94267a",
            "internalReferenceNumber": "FR-000002",
            "referenceNumber": "25HRYOJ8ZGX827",
            "verificationNumber": "REHOPX3C",
            "status": "AVAILABLE",
            "date": "2025-03-19T18:45:00.000Z",
            "updatedBy": "Sophie Martin"
        }
    ]
}`}
      />

      <Typography variant="h6" sx={{ mt: 2 }}>
        Response Codes
      </Typography>
      <TableContainer component={Paper} sx={{ mt: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Code</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>200</TableCell>
              <TableCell>Request successful</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>400</TableCell>
              <TableCell>Bad request - missing or invalid parameters</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>401</TableCell>
              <TableCell>Unauthorized - invalid credentials</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>404</TableCell>
              <TableCell>Statement not found</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>500</TableCell>
              <TableCell>Server error</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>


    </Box>
  );
}

export default GetDdsByReference; 